import { render, staticRenderFns } from "./TextareaType.vue?vue&type=template&id=69ff7d83&"
import script from "./TextareaType.vue?vue&type=script&lang=js&"
export * from "./TextareaType.vue?vue&type=script&lang=js&"
import style0 from "./TextareaType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports